import gsap from 'gsap'
import { bp, callAfterResize, mm, preventOrphan, sel, selAll, stResizeObserver, wrapLastTwo } from './utils'
import { SplitText } from 'gsap/SplitText'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { VidstackPlayer, VidstackPlayerLayout } from 'vidstack/global/player'

gsap.registerPlugin(SplitText, ScrollTrigger)

export default function Exec() {
  // window.addEventListener('load', function () {
  document.fonts.load('1rem "DM Sans"').then(() => {
    // console.log('Epic.js loaded')
    const navbarW$ = sel('.navbar-a')
    const navbar$ = sel('#navbar')
    const hero$ = sel('.hero')
    gsap.set(hero$, { zIndex: 30 })
    // const compInfo$ = header$.querySelector('.hero__info--epic')
    const heroP$ = hero$.querySelector('.hero__p--epic')
    const heroBtn1$ = hero$.querySelectorAll('.btn')[0]
    const heroBtn2$ = hero$.querySelectorAll('.btn')[1]

    const heroBg$ = hero$.querySelector('.hero__epic-svg')
    const heroTag$ = hero$.querySelector('.hero__tag--epic')
    // const compHsT = new SplitType('.comp-hero__h', { types: 'words, chars' })
    const compHsT = SplitText.create('.h1--epic', { type: 'chars, words' }) // words to keep the initial wrapping
    const epicSvgW$ = sel('.epic--hero--img')

    // gsap.set(navbarW$, { backgroundColor: 'black' })
    mm.add(bp.tabUp, () => {
      gsap
        .timeline({ defaults: { ease: 'power4.out', duration: 2 } })
        // .from(compHeroBg$, { scale: 1.1, ease: 'power1.out', duration: 3 })
        // .from(navbar$, { autoAlpha: 0, duration: 1.5, ease: 'none' }, '<+0.15')
        .from(
          compHsT.chars,
          {
            autoAlpha: 0,
            filter: 'blur(50px)',
            stagger: {
              amount: 1.25,
              // from: 'end',
            },
            duration: 0.5,
            ease: 'none',
            // ease: 'power1.out',
          },
          0.5
        )
        .from(heroP$, { autoAlpha: 0, y: -20, duration: 2 }, '>-0.5')
        .from(navbar$, { opacity: 0, duration: 2.5, ease: 'none' }, '<.5')
        .from(heroBtn1$, { autoAlpha: 0, y: -20 }, '<0.25')
        .from(heroBtn2$, { autoAlpha: 0, y: -20 }, '<0.1')
        // .from(heroBg$, { autoAlpha: 0, duration: 10, ease: 'none' }, 9)
        .from(heroBg$, { autoAlpha: 0, duration: 10, ease: 'none' }, '<+0.15')
        .from(heroTag$, { autoAlpha: 0 }, '<+0.15')
      // .from(sub$, { autoAlpha: 0 }, '<+0.15')

      gsap.to(heroBg$, { rotate: -360, duration: 300, repeat: -1, ease: 'none' })

      const intro$ = sel('.epic-intro-sec')
      const introBg$ = sel('.epic-intro__bg-w')
      const introVidBg$ = sel('.epic-intro__vid-bg-w')
      const introH$ = intro$.querySelector('h2')
      const introHsT = SplitText.create(introH$, { type: 'chars, words' })
      // const introHsT = SplitText.create(introH$, { type: 'chars, words, lines', linesClass: 'st-line', mask: 'lines' })
      gsap.set(hero$, { marginBottom: '-100vh' })
      // gsap.set(introVidBg$, { scale: 1.2, transformOrigin: 'bottom center' })
      gsap.set(introVidBg$, { scale: 1.2 })
      const introTl = gsap
        .timeline({ defaults: { ease: 'none', duration: 2 } })
        .from(introBg$, { scale: 1.2, autoAlpha: 0, ease: 'power1.out', duration: 7 })
        .from(introVidBg$, { autoAlpha: 0, scale: 1, duration: 7 }, '<')
        // .from(introVidBg$, { autoAlpha: 0, y: '20vh', duration: 7 }, '<')
        .from(
          introHsT.chars,
          {
            autoAlpha: 0,
            filter: 'blur(50px)',
            stagger: {
              each: 0.04,
            },
            duration: 1.5,
          },
          0.5
        )
        .from(intro$, { marginBottom: '-100vh' }, 5)
      ScrollTrigger.create({
        trigger: hero$,
        start: 'top top+=1',
        end: '300%',
        // end: 'top top',
        // end: 'top+=' + vh(50) + ' top',
        // end: '+=' + vh(100),
        scrub: true,
        pin: intro$,
        animation: introTl,
        onUpdate: (self) => {
          // Update the intro section's position based on the scroll progress
          const progress = self.progress
          // console.log('Scroll progress:', progress)
          // gsap.set(intro$, { y: `${progress * 100}vh` });
          if (progress > 50) {
          }
        },
      })
    })

    // Props sec
    const propList$ = sel('.epic-props__list')
    const prop$a = selAll('.epic-props__item')
    const prop1$ = prop$a[0]
    const prop1ImgWW$ = prop1$.querySelector('.epic-props__img-w-w')
    const prop1ImgW$ = prop1$.querySelector('.epic-props__img-w')
    const prop1InfoWW$ = prop1$.querySelector('.epic-props__item__info-col-w')
    const prop1InfoW$ = prop1$.querySelector('.epic-props__item__info-col')
    const propDim$ = prop1$.querySelector('.epic-props__item__dim-w')

    prop$a.forEach((prop$, i) => {
      console.log(prop$)
      const propTl = gsap.timeline({ defaults: { duration: 1, ease: 'none' } })
      const p$a = prop$.querySelectorAll('.p--epic')
      const info$ = prop$.querySelector('.epic-props__item__info')

      // console.log(prop$)
      if (i > 0) {
        const img$ = prop$.querySelector('.epic-props__img')

        // if (i === prop$a.length - 1) gsap.set(info$, { minHeight: 'auto' })
        gsap.set(img$, { autoAlpha: 0 })
        prop1ImgW$.appendChild(img$)
        prop1InfoW$.appendChild(info$)
        const propH$ = info$.querySelector('.h3--epic')
        prop$.remove()

        gsap.to(img$, {
          autoAlpha: 1,
          duration: 0.5,
          ease: 'none',
          scrollTrigger: {
            trigger: propH$,
            start: 'top bottom',
            toggleActions: 'play none none reverse',
            // end: '30%',
            // scrub: true,
            // markers: true,
          },
        })
      }
      if (p$a.length > 1) {
        // console.log(p$a[0])
        let prevP$ = p$a[0]
        p$a.forEach((p$, i) => {
          if (i > 0) {
            gsap.set(p$, { position: 'absolute', top: 0, left: 0 })
            // console.log('cur:', p$, 'prev:', prevP$)
            propTl.to(prevP$, { autoAlpha: 0, ease: 'power4.out' }, i - 1)
            propTl.from(p$, { autoAlpha: 0, ease: 'power4.out' }, i - 0.5)
          }
          prevP$ = p$
        })
        ScrollTrigger.create({
          trigger: info$,
          start: 'center center',
          end: (p$a.length - 1) * 150 + '%',
          // end: '+100vh',
          scrub: true,
          pin: true,
          // pinSpacing: true,
          animation: propTl,
          snap: 1 / (p$a.length - 0.5),
          // markers: true,
        })
      }
    })
    const propInfoHeight$ = prop1InfoW$.getBoundingClientRect().height

    // const propTl = gsap.timeline({ defaults: { duration: 1, ease: 'none' } }).to(prop1InfoW$, { y: -propInfoHeight$ }, 0)
    ScrollTrigger.create({
      trigger: prop1InfoWW$,
      start: 'top top',
      // end: (p$a.length - 1) * 200 + '%',
      end: 'bottom bottom',
      scrub: true,
      pin: prop1ImgWW$,
      // pin: propList$,
      // animation: propTl,
      pinSpacing: false,
      // markers: true,
    })
    ScrollTrigger.create({
      trigger: prop1InfoWW$,
      start: 'top top',
      end: 'bottom bottom',
      scrub: true,
      pin: propDim$,
      pinSpacing: false,
    })

    // Test

    const epic$ = sel('.epic-props-sec')
    const testW$ = sel('.epic-test-sec-w')
    const test$ = sel('.epic-test-sec')
    const testC$ = sel('.epic-test__c')
    const testA$ = test$.querySelector('.btn')
    const tableW$ = sel('.epic-table-sec-w')
    const table$ = sel('.epic-table-sec')
    gsap.set(test$, { marginTop: '-100vh' })
    // gsap.set(test$, { marginTop: '-100vh', marginBottom: '-100vh' })

    const testTl = gsap.timeline({ defaults: { ease: 'none', duration: 1 } })
    ScrollTrigger.create({
      trigger: epic$,
      start: 'bottom bottom',
      end: '+=100%',
      // end: '+=200%',
      scrub: true,
      pin: test$,
      // pinSpacing: false,
      // animation: testTl,
    })
    async function videoModal() {
      const videoBtn$ = sel('#customPlayerBtn')
      if (!videoBtn$) return

      const sec$ = sel('.epic-test-sec')
      const modW$ = sel('body').appendChild(sec$.querySelector('.mod-w'))

      const close$ = modW$.querySelector('.mod__x-w')
      const mod$ = modW$.querySelector('.mod')
      const bg$ = modW$.querySelector('.mod-bg')
      modW$.classList.add('display-hide')

      const _player = modW$.querySelector('.custom_player')
      // console.log(_player.getAttribute('src'))
      const src = _player.getAttribute('data-src') || 'youtube/4UgnVc7kRxE'
      const player = await VidstackPlayer.create({
        target: _player,
        src: src,
        // src: 'vimeo/1061484821',
        poster:
          'https://cdn.prod.website-files.com/655b9a852f3d2a5de3c90048/6826898440714274aa9fd120_67575b133690ca3c5bb9254a_test_img1_q85-gigapixel-low%20resolution%20v2-4x%20copy.webp',
        crossOrigin: true,
        playsInline: true,
        viewType: 'video',
        load: 'idle',
        layout: new VidstackPlayerLayout(),
      })

      const tl = gsap
        .timeline({ defaults: { duration: 1, ease: 'power4.inOut' }, paused: true })
        .to(
          {},
          {
            onStart: () => {
              modW$.classList.remove('display-hide')
            },
            onReverseComplete: () => {
              modW$.classList.add('display-hide')
            },
            duration: 0.1,
          }
        )
        .to(modW$, { opacity: 1 })
        .from(mod$, { y: 50 }, 0)

      const closeModal = (e) => {
        e?.stopImmediatePropagation()
        tl.reverse()
        player.pause()
      }

      videoBtn$.onclick = (e) => {
        // console.log('pl', player.state.canPlay)
        tl.play()

        if (player.state.canPlay) {
          player.play()
        } else {
          player.addEventListener(
            'can-play',
            (event) => {
              // console.log('canplay')
              player.play()
            },
            { once: true }
          )
        }
      }
      ;[close$, bg$].forEach((el) => {
        el.onclick = closeModal
      })

      player.addEventListener('ended', (event) => {
        closeModal()
      })

      callAfterResize(() => closeModal())
      // console.log('videoBtn$', videoBtn$)
    }
    videoModal()

    // Table
    const tableTab$a = selAll('.epic-table__col.is--header')
    tableTab$a.forEach((tab$) => {
      const tabColClass = tab$.dataset.col
      // console.log('tabColClass', tabColClass)

      tab$.addEventListener('click', function () {
        // console.log('tabColClass', tabColClass)
        tableTab$a.forEach((tab$) => {
          if (this === tab$) return
          tab$.classList.remove('is--active')
          this.classList.add('is--active')

          const dataClass = this.dataset.col
          const dataItem$a = selAll('.epic-table__col.is--data')
          dataItem$a.forEach((item$) => {
            if (item$.classList.contains(dataClass)) {
              item$.style.display = 'flex'
            } else {
              item$.style.display = 'none'
            }
          })
        })
      })
    })

    const tableTable$ = sel('.epic-table')
    const tableCol1Cell$a = selAll('.epic-table__col.is--1')
    const tableCol2Cell$a = selAll('.epic-table__col.is--2')
    const tableCol3Cell$a = selAll('.epic-table__col.is--3')
    const tableCol4Cell$a = selAll('.epic-table__col.is--4')
    const rowTw = {
      x: 10,
      autoAlpha: 0,
      stagger: 0.1,
      ease: 'power1.out',
    }
    const tableTl = gsap
      .timeline({ defaults: { ease: 'none', duration: 1 } })
      .from(tableCol1Cell$a, rowTw, 0)
      .from(tableCol2Cell$a, rowTw, 0)
      .from(tableCol3Cell$a, rowTw, 0)
      .from(tableCol4Cell$a, rowTw, 0)
    ScrollTrigger.create({
      trigger: tableTable$,
      start: 'top 60%',
      // end: '+=100%',
      // scrub: true,
      //
      toggleActions: 'play none none reverse',
      animation: tableTl,
    })

    mm.add(bp.tabUp, () => {
      const cta$ = sel('.epic-cta-sec')
      const ctaH$ = cta$.querySelector('h2')
      const ctaHsT$ = SplitText.create(ctaH$, { type: 'words, chars' })
      const ctaP$ = cta$.querySelector('.epic-cta__info>div:not(.button-group)')
      const ctaBtn$ = cta$.querySelector('.btn')
      const ctaBg$ = cta$.querySelector('.epic-cta__bg-w')
      const ctaSvgBgW$ = cta$.querySelector('.epic-cta__svg-w')
      const ctaSvgBg$ = cta$.querySelector('.epic-cta__svg')
      const footer$ = sel('.footer')

      const ctaTl = gsap
        .timeline({ defaults: { ease: 'power3.out', duration: 1 } })
        //
        .from(
          ctaHsT$.chars,
          {
            autoAlpha: 0,
            filter: 'blur(50px)',
            stagger: 0.03,
            ease: 'none',
          },
          0
        )
        .from(ctaP$, { autoAlpha: 0, y: -20 }, '<50%')
        .from(ctaBtn$, { autoAlpha: 0, y: -20 }, '<10%')
        .from(footer$, { y: 20, autoAlpha: 0, duration: 3 }, '<10%')

      ScrollTrigger.create({
        trigger: cta$,
        start: 'top 80%',
        // end: '+=100%',
        // scrub: true,
        animation: ctaTl,
        toggleActions: 'play none none reverse',
      })
    })
    // const ctaBgTl = gsap.timeline({ defaults: { ease: 'none', duration: 1 } }).fromTo(ctaBg$, { y: -100 }, { y: 150 })
    // gsap.to(ctaSvgBgW$, { filter: 'drop-shadow(50px 124px 200px rgba(167, 117, 115, 0.40))', duration: 3, repeat: -1, yoyo: true })
    // .to(ctaSvgBg$, { y: 100 })
    // ScrollTrigger.create({
    //   trigger: cta$,
    //   start: 'top bottom',
    //   end: 'bottom top',
    //   scrub: true,
    //   animation: ctaBgTl,
    // })
  })
  stResizeObserver()
  // console.log('Epic.js executed')
}
